export default __webpack_public_path__ + "static/media/twitter.f3a25050.svg";